import useUsasClubFacilityLinksData from '../../../state/clubFacilityLinks/UseUsasClubFacilityLinksData';

import useFacilityData from '@usas/ui-web/state/facility/UseFacilityData';

const useClubFacilitiesPoolsDetail = () => {
  const { usasClubFacilityLinksState } = useUsasClubFacilityLinksData();
  const { facilityState } = useFacilityData();

  return {
    usasClubFacilityLinksState,
    facilityState
  };
};

export default useClubFacilitiesPoolsDetail;